import { checkValue } from "../../../functions/checkValue";
import { formatDate } from "../../../functions/dateTime/formatDate";
export const formatSiteExcelData = (sitesData) => {
  return sitesData.map((s) => ({
    "Site ID": String(s.id),
    "Site Name": s.name,
    "Machine ID": checkValue(s.machineID),
    Category: s.category?.name,
    "Field Technician": checkValue(s.jbccFieldTechnician?.fullName),
    Supervisor: checkValue(s.jbccFieldTechnician?.jbccSupervisor?.fullName),
    Subdivision: checkValue(s.je.subDivision?.name),
    Automation: s.isAutomation ? "YES" : "NO",
  }));
};

export const formatUnvisitedSitesExcelData = (sitesData) => {
  return sitesData.map((s) => ({
    "Site ID": String(s.id),
    "Site Name": s.name,
    "Last Visit Date": formatDate(s.lastVisit),
    "Days Since Visit": `${s.daysSinceLastVisit} Days`,
    "Field Technician": s.jbccTechnicianName,
    "Field Technician Phone": s.jbccTechnicianPhone,
    Supervisor: s.jbccSupervisorName,
    "Supervisor Phone": s.jbccSupervisorPhone,
  }));
};

export const formatRepairExcelData = (sitesData) => {
  return sitesData.map((s) => ({
    "Site ID": String(s.station.id),
    "Site Name": s.station.name,
    "Machine ID": String(checkValue(s.station?.machineID)),
    "Repair Date": formatDate(s.repairDate),
    "Work Done": s.workDone?.map((work) => work.name).join(", "),
    "Field Technician": checkValue(s.station.jbccFieldTechnician?.fullName),
    Supervisor: checkValue(
      s.station.jbccFieldTechnician?.jbccSupervisor?.fullName,
    ),
    Sub_Division: checkValue(s.station.je?.subDivision?.name),
  }));
};

export const formatDeactivatedSitesExcelData = (sitesData) => {
  return sitesData.map((s) => ({
    "Site ID": String(s.id),
    "Site Name": s.name,
    "Machine ID": String(checkValue(s.machineID)),
    Subdivision: checkValue(s.je.subDivision?.name),
    Automation: s.isAutomation ? "YES" : "NO",
  }));
};
